module.exports = __webpack_public_path__ + "img/abacus.daa2c001.svg";